import { DetailAction } from './DetailAction';
import { DetailTranslationKeys } from '../../../api/models/TranslationKeys';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { OttStream, VodStreamRights } from '../vod/VodStreamRights';
import { VodStreamInfo } from '../../player/streamInfo/VodStreamInfo';
import { StartPositionType } from '../../player/streamInfo/StreamInfo';
import { Backend } from '../../../api/Backend';
import { IStreamPriceResponse3 } from '../../../api/models/AndromeTV.types';
import { VodAsset } from '../vod/VodAsset';
import { OptionData } from '../../../components/option/OptionData';
import { Router } from '@lightningjs/sdk';

export class WatchTrailerAction extends DetailAction {
  private trailerStreams: IStreamPriceResponse3[];
  private vod: VodAsset;
  private streamRights: VodStreamRights | undefined;
  constructor(backend: Backend, trailerStreams: IStreamPriceResponse3[], vod: VodAsset) {
    super(backend);
    this._backend = backend;
    this.trailerStreams = trailerStreams;
    this.vod = vod;
  }

  override doAction() {
    if (!this._backend.isAuthorized() && !this.streamRights?.hasWatchableOttFVOD()) {
      //TODO show login menu, check streamRights not initialized
      return;
    }

    if (this.trailerStreams.length === 1) {
      this.startTrailerStream(this.trailerStreams[0]!);
    } else if (this.trailerStreams.length > 1) {
      this.showOptions();
    }
  }

  showOptions() {
    const options = this.trailerStreams.map((stream, index) => ({
      text: `${this._backend.translations.forKey(DetailTranslationKeys.detail_btn_trailer)} ${index + 1} (${
        stream.resolution
      })`,
      value: stream,
    }));
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        name: 'Select watch option',
        title: this._backend.translations.forKey(DetailTranslationKeys.detail_btn_trailer),
        options,
        onSuccess: (val: OptionData) => {
          this.hideOptions();
          this.startTrailerStream(val.value);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }

  startTrailerStream(stream: IStreamPriceResponse3) {
    const streamInfo = new VodStreamInfo(this.vod, new OttStream(stream, []), undefined, StartPositionType.START);
    Router.navigate('play', { streamInfo });
  }
}
